import React, { useEffect, useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import { collection, addDoc, setDoc, doc} from "firebase/firestore"; 
import {ref, uploadBytes, deleteObject, getDownloadURL, getStorage, uploadBytesResumable } from "firebase/storage"
import { db, storage } from "../firebase-config";
import Financeurs from './Financeurs';
import {v4 as uuidv4} from 'uuid'
import { IoMdCamera } from "react-icons/io";
import { FaCircleMinus } from "react-icons/fa6";

const Form = () => {


    const [validation, setValidation] = useState("")
    const formRef = useRef()
    const [dataStructure, setDataStructure] = useState("");
    const [dataContrat, setDataContrat] = useState("");
    const [dataSecteurDactivite, setDataSecteurDactivite] = useState("");
    const [dataIntitule, setDataIntitule] = useState("");
    const [dataMission, setDataMission] = useState("");
    const [dataCompetences, setDataCompetences] = useState("");
    const [dataConditions, setDataConditions] = useState("");
    const [dataContact, setDataContact] = useState("");
    const [dataParticipate, setDataParticipate] = useState("");
    const [dataLogo, setDataLogo] = useState("");

    const [validationMessage, setValidationMessage] = useState("")

    const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
          mode: 'onChange',
          defaultValues: "",
    })

    const onSubmit = async data  => {

        var id = uuidv4()
       

    try {

        const preSubInfo = {
          ID: id, 
          NOM: data.nom ? data.nom : "Non renseigné",
          PRENOM: data.prenom ? data.prenom : "Non renseigné",
          STRUCTURE: data.organisme ? data.organisme : "Non renseigné",
          EMAIL: data.email ? data.email : "Non renseigné",
          PRESENCE: data.presence ? data.presence : "Non renseigné",
          DATE: new Date().toLocaleString().slice(0, 10)   
        }
        console.log(preSubInfo)

        console.log(data)
        const ref = doc(db, "reunionPleniere", id);
        const docRef = setDoc(ref, preSubInfo)
        setValidation(["Votre inscription a bien été enregistrée", "Success"])
  

      }
              catch(err) {
              console.log(err);
              setValidation(["Une erreur s'est produite veuillez rééssayer ultérieurement", "Error"])

          }
      
          formRef.current.reset("");
        

          
}
    return (
        <>
         
            <div className="container">

             
            
                 <form ref={formRef} id="sign-in" onSubmit={handleSubmit(onSubmit)}>
                  {validation && <div className={ validation[1] === "Success" ? "success" : "error"}>{validation[0]}</div>}
                  <div className="left">
                    <img style={{maxWidth: "485px", margin: "0 auto"}} src="https://agorajobs.fr/reunion-pleniere-form/Assets/affiche.jpg" alt="" />
                  </div>
                  <div className="right">

                    <h4 className='required'>Les champs marqués d'un * sont requis</h4>
                        <input {...register('nom', {required: true})} type="text" name="nom" id="" placeholder="Nom *"/>
                        {errors.nom?.type === "required" && (
                          <small>Ce champ est requis</small>
                        )}
                        <input {...register('prenom', {required: true})} type="text" name="prenom" id="" placeholder="Prénom *"/>
                        {errors.prenom?.type === "required" && (
                          <small>Ce champ est requis</small>
                        )}
                        <input {...register('organisme', {required: true})} type="text" name="organisme" id="" placeholder="Entreprise ou Organisme *"/>
                        {errors.organisme?.type === "required" && (
                               <small>Ce champ est requis</small>
                        )}
                        <input {...register('email', {required: true})} type="email" name="email" id="" placeholder="Adresse email *"/>
                        {errors.email?.type === "required" && (
                               <small>Ce champ est requis</small>
                        )}

                        <label htmlFor="">Serez-vous présent à cette réunion ? *</label>
                        <div className="chx" style={{display: "grid", gridTemplateColumns: "50% 50%", width: "40%", margin: "20px auto", alignItems: "center"}}>
                          <div className="row">
                            <input {...register('presence', {required: true})} type="radio" value="Oui" name="presence" id="" />
                            <label htmlFor="Oui" style={{color: "#000"}}>Oui</label>
                          </div>
                          <div className="row">
                           <input {...register('presence', {required: true})} type="radio" value="Non" name="presence" id="" />
                           <label htmlFor="Non" style={{color: "#000"}}>Non</label>
                          </div>
                        </div>

                    </div>
                    <p style={{textAlign: "center", margin: "20px 0"}}>Pour inscrire plusieurs personnes, merci de remplir plusieurs fois le questionnaire.</p>

                    <button className="btn" id="button">Envoyer</button>
                     
                     
                    </form>
                    <Financeurs /> 
                </div>
     
        </>
    );
};

export default Form;